import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './organism/login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RecoverPasswordCardComponent } from './organism/recover-password-card/recover-password-card.component';
import { CoreUiButtonsModule, CoreUiInputsModule, CoreUiAlertsModule } from 'lib-klab-core-ui';

@NgModule({
  declarations: [
    LoginComponent,
    RecoverPasswordCardComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CoreUiInputsModule,
    CoreUiButtonsModule,
    CoreUiAlertsModule,
  ],
  exports: [
    LoginComponent,
    RecoverPasswordCardComponent
  ],
})
export class MicrosUISecurityModule { }
